import { BenQuery } from './BenQuery'
import { BenSwiper } from './BenSwiper'
export class BenSw {
  static init(dones, app) {
    const $sw = BenQuery.query('[ben-js="sw"]')
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item)
    })
  }
}

async function _init($sw: HTMLElement) {
  const type = $sw.getAttribute('type')
  const id = $sw.getAttribute('id') || ''
  const control = $sw.getAttribute('control') || 'on'
  const bind = $sw.getAttribute('bind') || ''
  let initialSlide = $sw.getAttribute('initial-slide') || 0
  initialSlide = Number(initialSlide) || 0
  const perView = $sw.getAttribute('per-view') || undefined
  const breakpoints = $sw.getAttribute('breakpoints') || undefined
  let allowTouchMove = $sw.getAttribute('touch-move') || true
  let autoHeight = $sw.getAttribute('auto-height') || false
  autoHeight = !!autoHeight
  const autoplay = $sw.getAttribute('autoplay') ? true : false
  allowTouchMove = allowTouchMove === '0' ? false : true
  const effect = $sw.getAttribute('effect') || undefined
  const spaceBetween = Number($sw.getAttribute('between')) || 0
  const loop = $sw.hasAttribute('loop')
  const innerHTML = $sw.innerHTML
  if (control !== 'none') {
    const preAddHtml = `<div class="pagination"></div>
    <div class="prev btn">
    <svg><use xlink:href="#icon-next"></use></svg>
    </div>
    <div class="next btn">
    <svg><use xlink:href="#icon-next"></use></svg>
    </div>`
    $sw.innerHTML = preAddHtml + innerHTML
  }
  await BenQuery.nextTick()
  const pagination = $sw.querySelector(':scope > .pagination')
  const prevEl = $sw.querySelector(':scope > .prev')
  const nextEl = $sw.querySelector(':scope > .next')
  const $swiper = $sw.querySelector('.swiper') as HTMLElement
  if (type === 'coverflow') {
    BenSwiper.initCoverflow($swiper, { spaceBetween, pagination, prevEl, nextEl, perView, loop })
  } else if (type === 'normal') {
    BenSwiper.init($swiper, { id, bind, spaceBetween, initialSlide, pagination, prevEl, nextEl, loop, autoplay, perView, breakpoints, effect, control, allowTouchMove, autoHeight })
  }
}
